import type { IconNode } from '../types';

/**
 * @name surfboard
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMjIgMiAyLjYgMjEuNCIgLz4KICA8cGF0aCBkPSJNMTMuOCAxOS4yQTE4IDE4IDAgMCAwIDIyIDRWMmgtMkMxMC4xIDIgMiAxMC4xIDIgMjBhMiAyIDAgMCAwIDIgMiAxNyAxNyAwIDAgMCA3LjYzLTEuNyIgLz4KICA8cGF0aCBkPSJNNyAxN2MyLjcgMCA0LjkgMi4zIDUgNWE2LjcgNi43IDAgMCAwLS4xLTkuOSIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/surfboard
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const surfboard: IconNode = [
  ['path', { d: 'M22 2 2.6 21.4', key: 'nmcf6e' }],
  [
    'path',
    {
      d: 'M13.8 19.2A18 18 0 0 0 22 4V2h-2C10.1 2 2 10.1 2 20a2 2 0 0 0 2 2 17 17 0 0 0 7.63-1.7',
      key: 'b5bj56',
    },
  ],
  ['path', { d: 'M7 17c2.7 0 4.9 2.3 5 5a6.7 6.7 0 0 0-.1-9.9', key: '585k8i' }],
];

export default surfboard;
